'use client';
import { createContext } from 'react';

import { Slide } from '@/api/cms';

export interface ILobbyContext {
  promoSlides: Slide[];
}

export const LobbyContext = createContext<ILobbyContext | null>(null);

export function LobbyProvider({
  promoSlides,
  children,
}: {
  promoSlides: Slide[];
  children: React.ReactNode;
}) {
  return (
    <LobbyContext.Provider
      value={{
        promoSlides,
      }}
    >
      {children}
    </LobbyContext.Provider>
  );
}
